export default {
  tableTitle: {
    id: 'bo_sellers_customer_care_all_requests_table_aria_label',
    defaultMessage: 'All requests table',
  },
  statusHeader: {
    id: 'bo_sellers_customer_care_all_requests_table_head_status',
    defaultMessage: 'Status',
  },
  taskHeader: {
    id: 'bo_sellers_customer_care_all_requests_table_head_task',
    defaultMessage: 'Task',
  },
  lastActionTakenHeader: {
    id: 'bo_sellers_customer_care_all_requests_table_head_last_action_taken',
    defaultMessage: 'Last action taken',
  },
  issueTypeHeader: {
    id: 'bo_sellers_customer_care_all_requests_table_head_issue_type',
    defaultMessage: 'Issue type',
  },
  orderIdHeader: {
    id: 'bo_sellers_customer_care_all_requests_table_head_order_id',
    defaultMessage: 'Order #',
  },
  customerHeader: {
    id: 'bo_sellers_customer_care_all_requests_table_head_customer',
    defaultMessage: 'Customer',
  },
  statusTooltip: {
    id: 'bo_sellers_customer_care_all_requests_table_status_tooltip',
    defaultMessage: 'Status deadlines are in business days.',
  },
}
